import * as React from 'react';
export const airtableSvg = React.forwardRef(function airtableSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.718 6.254 5.764 9.958c-.502.204-.489.91.013 1.112l8.98 3.569a3.339 3.339 0 0 0 2.458 0l8.98-3.569a.602.602 0 0 0 .014-1.112l-8.954-3.704a3.29 3.29 0 0 0-2.537 0Z',
      fill: '#FCB400',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.793 16.578v8.9c0 .42.42.72.814.556l10.014-3.88A.603.603 0 0 0 28 21.6v-8.914c0-.42-.42-.72-.814-.556l-10.014 3.893a.576.576 0 0 0-.379.557v-.001Z',
      fill: '#18BFFF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm14.446 17.027-2.97 1.437-.3.15-6.267 3.011c-.394.19-.909-.095-.909-.542v-8.357a.576.576 0 0 1 .19-.408.603.603 0 0 1 .149-.108.633.633 0 0 1 .542-.041l9.51 3.772c.49.19.53.868.056 1.086h-.001Z',
      fill: '#F82B60',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm14.446 17.027-2.97 1.437-7.286-6.145a.604.604 0 0 1 .149-.108.632.632 0 0 1 .542-.042l9.51 3.772c.49.19.53.868.056 1.086h-.001Z',
      fill: '#BA1E45',
    }),
  );
});
airtableSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var airtable = {
  category: 'brand',
  colorable: false,
  name: 'airtable',
  svg: airtableSvg,
};
